import { createRouter, createWebHistory } from 'vue-router';

import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

// page
import Campaign from '@/module/Detail/page/Campaign.vue';
import Category from '@/module/List/page/Category.vue';
import CollectPoint from '@/module/CollectPoint/page/CollectPoint.vue';
import History from '@/module/History/page/History.vue';
import Home from '@/module/Home/page/Home.vue';
import Privilege from '@/module/List/page/Privilege.vue';
import Profile from '@/module/Profile/page/Profile.vue';
import TailwindMain from '@/module/Example/Tailwind/page/TailwindMain.vue';
import TailwindDetail from '@/module/Example/Tailwind/page/Detail.vue';
import TailwindFooterBottom from '@/module/Example/Tailwind/page/FooterBottom.vue';
// address
import DeliveryAddress from '@/module/Address/DeliveryAddress/page/DeliveryAddress.vue';
import TaxAddress from '@/module/Address/TaxAddress/page/TaxAddress.vue';
// static
import Pdpa from '@/module/Static/Pdpa/page/Pdpa.vue';

const routes = [
    {
        path: '/',
        name: 'default',
        component: Default
    },
    // template
    {
        path: '/campaign/:campaignId',
        name: 'campaign',
        component: Campaign,
    },
    {
        path: '/category/:catId?',
        name: 'category',
        component: Category,
    },
    {
        path: '/history',
        name: 'history',
        component: History,
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
    },
    {
        path: '/privilege',
        name: 'privilege',
        component: Privilege,
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
    },
    {
        path: '/tailwind',
        name: 'tailwind',
        component: TailwindMain,
    },
    {
        path: '/tailwind/detail',
        name: 'tailwind_detail',
        component: TailwindDetail,
    },
    {
        path: '/tailwind/footer',
        name: 'tailwind_footer',
        component: TailwindFooterBottom,
    },
    
    {
        path: '/address/delivery',
        name: 'address_delivery',
        component: DeliveryAddress,
    },
    {
        path: '/address/tax',
        name: 'address_tax',
        component: TaxAddress,
    },
    // page
    {
        path: '/collectpoint',
        name: 'collect point',
        component: CollectPoint
    },
    // static
    {
        path: '/privacy',
        name: 'privacy',
        component: Pdpa
    },
    {
        path: '/terms',
        name: 'terms',
        component: Pdpa
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
